<template>
  <div class="main">
    <div class="list-bg"><img :src="bkimg" alt=""></div>
    <div class="contain">
      <div class="navigate pointer">
        <span :class='{"lastnav":index==navigate.length-1}' v-for='(nav,index) in navigate' :key='index' @click="goto(index)">{{nav}}<span class='lastnav' v-show='index != navigate.length-1'>></span></span>
      </div>
      <div class="snav">
        <div class="navtop">
          <span class='typefirst'>主题</span>
          <span v-for='(type,index) in types' :key='index' :class='["type",{active:type.active}]' @click='selectType(index,type.id)'>{{type.tname}}</span>
        </div>
        <div class="navtop sec">
          <span class='typefirst'>热度</span>
          <span v-for='(hot,index) in hots' :key='index' :class='["type",{active:hot.active}]' @click='selectHot(index,hot.name)'>{{hot.name}}</span>
        </div>
      </div>
      <past :lists='lists'></past>
      <p class='more' @click='more' v-if='lists.length<total'>点击加载更多</p>
      <p class='more' v-else>没有更多了...</p>
    </div>
  </div>
</template>
<script>
import {reviewlist} from '@/api/past.js'
import {getthemelist} from '@/api/theme.js'
import past from '@/components/past/past.vue'
export default {
  components: {
    past
  },
  data () {
    return {
      navigate: ['首页', '极地探险', '往期回顾'],
      types: [{name: '所有', active: false}, {name: '极地探险', active: false}, {name: '南极马拉松', active: false}, {name: '亲自活动', active: false}, {name: '国际游学', active: false}, {name: '轻摄影', active: false}],
      hots: [{name: '最新', active: true}, {name: '最热', active: false}],
      lists: [],
      querylist: {
        page: 1,
        limit: 15,
        themeid: undefined,
        ishot: undefined
      },
      total: undefined,
      bkimg: ''
    }
  },
  methods: {
    goto (index) {
      if (index === 0) {
        this.$router.push({path: '/index'})
      } else if (index === 1) {
        this.$router.push({path: '/routerLists'})
        this.$router.push({
          path: '/routerLists',
          query: {
            id: 1,
            img: 'https://tripolers.com.cn/admin/storage/fetch/fivqia2r3jovb14m0ihn.jpg',
            name: '极地探险'
          }
        })
      }
    },
    // 选择类型
    selectType (index, id) {
      for (let i = 0; i < this.types.length; i++) {
        this.types[i].active = false
      }
      this.types[index].active = true
      if (id === -1) {
        this.querylist.themeid = undefined
      } else {
        this.querylist.themeid = id
      }
      this.querylist.page = 1
      this.lists = []
      this.getlist()
    },
    // 选择热度
    selectHot (index, name) {
      for (let i = 0; i < this.hots.length; i++) {
        this.hots[i].active = false
      }
      this.hots[index].active = true
      if (name === '最热') {
        this.querylist.ishot = true
      }
      this.querylist.page = 1
      this.lists = []
      this.getlist()
    },
    // 点击加载更多
    more () {
      this.querylist.page += 1
      this.getlist()
    },
    // 跳转详情页
    gotodetal (id, img, title) {
      this.$router.push({
        name: 'PastReviewDetail',
        params: {
          id: id,
          img: img,
          title: title
        }
      })
    },
    getlist () {
      reviewlist(this.querylist).then(res => {
        this.lists = this.lists.concat(res.data.data.items)
        this.total = res.data.data.total
      })
    },
    // 获取主题列表
    getthemelist () {
      getthemelist().then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].active = false
        }
        this.types = items
        this.types.unshift({tname: '全部', id: -1, active: true})
      })
    }
  },
  mounted () {
    this.lists = []
  },
  created () {
    this.getthemelist()
    this.getlist()
    this.bkimg = this.$route.query.img
  }
}
</script>
<style scoped>
.main{
      background-color:#f4f4f4;
      padding-bottom:40px;
  }
  .pointer{
    cursor: pointer;
  }
  .contain{
    width:80rem;
    background-color: #fff;
    padding-bottom:3.75rem;
    margin: -200px auto 0;
    position: relative;
  }
  .list-bg {
        width: 100%;
        height: 672px;
        background: url(../static/images/past.png) no-repeat center;
        background-size: cover;
    }
  .list-bg img{
    width:100%;
    height: 672px;
  }
  .navigate{
    height:3.75rem;
    text-align:left;
    color:#0080cc;
    font-size:.875rem;
    line-height:3.75rem;
    padding-left:1.5rem;
    border-bottom:1px solid #dae1e6;
  }
  .navigate span{
    margin-left:.3125rem;
  }
  .lastnav{
    color:#60676d;
  }
  .typefirst{
    font: size 14px;
    color:#3a3f43;
    margin-left:1.5rem;
  }
  .type{
    font-size:14px;
    color:#8d969d;
    margin-left:1.875rem;
    cursor: pointer;
  }
  .active{
    color:#0080cc;
    font-weight:bold;
  }
  .snav{
    padding:1.5rem 0;
    background-color: #f9fbfc;
    border-bottom:1px solid #eff3f5;
  }
  .sec{
    margin-top: 1.25rem;
  }
  /* .content{
    margin:auto;
    margin-top:1.5rem;
    padding-bottom:1.25rem;
    width: 78.5rem;
    column-count: 3;
    column-width: 20.6875rem;
    column-gap: 1.5rem;
    width:96%;
  }
  .con{
    width:395px;
    break-inside: avoid;
    height: auto;
    position: relative;
    margin-bottom: 1.5rem;
    border:1px solid rgba(232, 232, 232, 1)
  } */
  /* .name{
    display:flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom:1.25rem;
  }
  .left{
    display:flex;
    align-items:center;
  }
  .left span{
    margin-left:.5rem
  }
  .pic{
    width:100%;
  }
  .title{
    font-size:1.125rem;
    color:#434343;
    margin:1.25rem .875rem;
  }
  .avartname{
    font-size:.875rem;
    color:#434343;
  }
  .concolor{
    font-size:.875rem;
    color:#7a7a7a;
  }
  .avart{
    width:1.875rem;
    height:1.875rem;
  }
  .listcontent,.name{
    margin:1.25rem .875rem;
  }
  .space{
    position:absolute;
    top:0;
    left:0;
    height:2.125rem;
    background-color: rgb(0,0,0,.2);
    color:#fff;
    font-size:.875rem;
    line-height: 2.125rem;
    padding: 0 .875rem;
  }
  .line{
    color:#d3d3d3;
    margin:0 .75rem;
  } */
  .more{
    font-size: .875rem;
    color:#6a7176;
    font-style:italic;
    text-align: center;
    margin-top:5.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/pastReview.vue